import * as React from "react";
import { Button, Field, Tooltip } from "@/components/ui";
import { CTA } from "@/services/bedrock";
import { Controller, useFormContext } from "react-hook-form";
import { LockIcon, UnlockIcon } from "lucide-react";
import { CallToActionField } from "@/components/CTAWizard";

type CtaFormValues = {
  allowCtaChange?: boolean;
  callToAction: CTA | null;
};

interface Props {
  disabled: boolean;
  playerId?: number;
  isLocked?: boolean;
}

const VideoPageCTA: React.FC<Props> = ({ playerId, disabled, isLocked }) => {
  const { control, watch, setValue } = useFormContext<CtaFormValues>();
  const callToAction = watch("callToAction");
  const canEdit = !disabled && !isLocked;

  const lockControl =
    isLocked === undefined ? (
      <Controller
        name="allowCtaChange"
        control={control}
        render={({ field }) => (
          <Tooltip>
            <Tooltip.Trigger
              render={
                <Button
                  type="button"
                  size="icon-sm"
                  variant={field.value ? "outline" : "default"}
                  disabled={disabled}
                  onClick={() => field.onChange(!field.value)}
                >
                  {field.value ? <UnlockIcon /> : <LockIcon />}
                </Button>
              }
            />
            <Tooltip.Content>
              {field.value ? "Lock the Call to Action to prevent changes" : "Unlock to allow Call to Action changes"}
            </Tooltip.Content>
          </Tooltip>
        )}
      />
    ) : isLocked ? (
      <Tooltip>
        <Tooltip.Trigger
          render={
            <Button type="button" size="icon-sm" variant="default" className="cursor-default" disabled={disabled}>
              <LockIcon />
            </Button>
          }
        />
        <Tooltip.Content>The Call to Action fields are locked to prevent changes</Tooltip.Content>
      </Tooltip>
    ) : null;

  return (
    <div className="flex flex-col gap-2">
      <Field
        name="callToAction"
        label={
          <div className="flex items-center gap-2">
            <div>Call to Action</div>
            {lockControl}
          </div>
        }
      >
        <CallToActionField
          value={callToAction}
          onChange={cta => setValue("callToAction", cta, { shouldDirty: true })}
          playerId={playerId}
          canEdit={canEdit}
        />
      </Field>
    </div>
  );
};
export default VideoPageCTA;
